<template>
    <div class="callback-private-v2">
        <slot name="heading">
            <div class="callback-private-v2__header factoid text-align-center">
                Присоединяйтесь<br>к нам
            </div>
        </slot>

        <div class="callback-private-v2__container">
            <div v-if="formStatus === EFormStatus.SUCCESS">
                <div class="_mb-40-16 callback-private-v2__status-img callback-private-v2__status-img_success" />
                <p class="text-align-center h3">
                    Заявка отправлена. Менеджер<br>свяжется с вами в течение часа
                </p>
            </div>
            <div v-else-if="formStatus === EFormStatus.ERROR">
                <div class="_mb-40-16 callback-private-v2__status-img callback-private-v2__status-img_error" />
                <p class="text-align-center h3">
                    Не удалось отправить заявку.<br>Попробуйте заполнить форму позже
                </p>
            </div>
            <div v-else>
                <div class="callback-private-v2__title _mb-40-24 text-align-center">
                    Оставьте заявку и мы ответим на все вопросы
                </div>
                <ui-form-field
                    label="Имя и фамилия"
                    :value="name"
                    :errors="nameErrors"
                    class="_mb-32-32"
                >
                    <template v-slot:default="{ id, errors }">
                        <UiTextInputSuggestions
                            :id="id"
                            :error="!!errors.length"
                            v-model="name"
                            name="name"
                            :suggestionType="ESuggestionTypes.NAME"
                            :suggestionPatrs="[EFioParts.NAME, EFioParts.SURNAME]"
                            :count="3"
                            dark
                            :disabled="formStatus === EFormStatus.LOADING"
                        />
                    </template>
                </ui-form-field>
                <ui-form-field
                    label="Телефон"
                    :errors="vuelidateErrorMesages.phone"
                    :value="$v.phone.$model"
                    class="_mb-32-32"
                >
                    <template v-slot:default="{ id, errors }">
                        <ui-text-input-masked
                            :id="id"
                            :error="errors.length > 0"
                            v-model="$v.phone.$model"
                            v-phone
                            mask="+7 ### ###-##-##"
                            placeholder="+7"
                            type="tel"
                            name="phone"
                            dark
                            :disabled="formStatus === EFormStatus.LOADING"
                        />
                    </template>
                </ui-form-field>
                <ui-form-field
                    :errors="vuelidateErrorMesages.isPolicyAgree"
                    :value="$v.isPolicyAgree.$model"
                    class="_mb-32-32"
                >
                    <template v-slot:default="{ id }">
                        <ui-checkbox
                            v-model="$v.isPolicyAgree.$model"
                            :id="id"
                            dark
                            :disabled="formStatus === EFormStatus.LOADING"
                        >
                            <template v-slot:label>
                                Я соглашаюсь с <a target="_blank" href="/upload/docs/cards/agreement.pdf" class="link">условиями обработки и использования персональных данных</a> и подтверждаю согласие на использование <a href="#" class="link" @click.stop.prevent="$modal.show('agreement_pep')">простой электронной подписи</a>
                            </template>
                        </ui-checkbox>
                    </template>
                </ui-form-field>
                <button
                    type="button"
                    class="button button_white _dblock _m-auto"
                    :disabled="formStatus === EFormStatus.LOADING"
                    @click="requestCode"
                >
                    Отправить заявку
                </button>
            </div>
        </div>

		<modal-with-yandex-captcha
            :requested="modalSmsShow"
			:phone="phone"
			endpoint="privateBankingServiceCallForm"
			:private-flag="true"
			@closeCaptchaSms="modalSmsShow = false"
			@smsConfirmed="sendForm"
		/>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { cyrWithDash, seemsDigitInPhone } from '../../assets/js/vue/validations';
import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
import vuelidateMessages from '../../assets/js/vue/validationsMessages';
import axios from 'axios';
import UiTextInputSuggestions from '../ui/UiTextInputSuggestions.vue';
import { EFioParts } from '../../assets/js/vue/utlis/useDadata/utils/EFioParts';
import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes';

const EFormStatus = Object.freeze({
    IDDLE: 0,
    LOADING: 1,
    SUCCESS: 2,
    ERROR: 3,
});

export default {
    name: 'CallbackPrivateV2',
    mixins: [validationMixin],
    components: {
        UiTextInputSuggestions,
    },
    data() {
        return {
            sessid: window.config.bitrix_sessid,
            second_name: undefined,
            first_name: undefined,
            phone: '',
            isPolicyAgree: false,
            modalSmsShow: false,
            formStatus: EFormStatus.IDDLE,
            EFormStatus,
            ESuggestionTypes,
            EFioParts,
        };
    },
    computed: {
        name: {
            get() {
                return [this.first_name, this.second_name].filter((item) => !!item).join(' ');
            },
            set(val) {
                const [first_name, second_name] = val.split(' ');
                this.first_name = first_name;
                this.second_name = second_name;

                this.$v.first_name.$touch();
                this.$v.second_name.$touch();
            },
        },
        vuelidateErrorMesages() {
            return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
        },
        nameErrors() {
            let nameErrors = [...this.vuelidateErrorMesages.first_name, ...this.vuelidateErrorMesages.second_name];

            nameErrors = nameErrors.filter((error, index) => index === nameErrors.findIndex(other => error.key === other.key && error.title === other.title ));
            return nameErrors;

            // return nameErrors.length > 0 ? [{
            //     key: 'custom',
            //     title: 'Ошибка валидации',
            // }] : [];
        },
        formData() {
            return {
                data: {
                    type: "privateBankingServiceCallForm",
                    attributes: {
                        fio: [this.second_name, this.first_name].join(' '),
                        phone: this.phone.replace(/\D/g, ''),
                        agreement: true
                    }
                }
            }
        }
    },
    validations: {
        second_name: {
            cyrWithDash,
            required,
        },
        first_name: {
            cyrWithDash,
            required,
        },
        phone: {
            required,
            seemsDigitInPhone: (val) => seemsDigitInPhone(val) && minLength(16)(val),
        },
        isPolicyAgree: {
            isAgreed: val => val
        },
    },
    methods: {
        requestCode() {
            if (this.modalSmsShow) return;

            this.$v.second_name.$touch();
            this.$v.first_name.$touch();
            this.$v.phone.$touch();
            this.$v.isPolicyAgree.$touch();

            if (!this.$v.$invalid) {
                this.modalSmsShow = true;
            }
        },
        sendForm() {
            this.formStatus = EFormStatus.LOADING;
            if (!this.$v.$invalid) {
                axios.post('/rest/v1/universal-form?sessid=' + this.sessid, this.formData)
                    .then(() => {
                        this.formStatus = EFormStatus.SUCCESS;
                        if (window.dmpkitdl) window.dmpkitdl.push({event: 'private-lead-fos-send'});
                    }).catch(err => {
                        this.formStatus = EFormStatus.ERROR;
                        console.error(err) // eslint-disable-line
                    }).finally(() => {
                        this.loading = false;
                    });

                this.$v.$reset();
            }
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

.callback-private-v2 {

    &__container {
        @include fluid('width', 592px);
        @include mobile {
            width: 100%;
        }
        margin-left: auto;
        margin-right: auto;
    }

    &__header {
        @include fluid('margin-bottom', 56px, 16px);
    }

    &__title {
        @include fluid('font-size', 20px, 14px);
        @include fluid('line-height', 20px, 28px);
        font-weight: 500;
    }

    &__status-img {
        @include fluid('width', 488px);
        @include mobile {
            width: 100%;
        }
        @include fluid('height', 286px, 168px);
        margin-left: auto;
        margin-right: auto;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    &__status-img_success {
        background-image: url('/local/templates/redesign/src/assets/img/private/callback/success.webp');
        @include retina {
            background-image: url('/local/templates/redesign/src/assets/img/private/callback/success@2.webp');
        }

        @include mobile {
            background-image: url('/local/templates/redesign/src/assets/img/private/callback/success_mob.webp');
            @include retina {
                background-image: url('/local/templates/redesign/src/assets/img/private/callback/success_mob@2.webp');
            }
        }
    }

    &__status-img_error {
        background-image: url('/local/templates/redesign/src/assets/img/private/callback/error.webp');
        @include retina {
            background-image: url('/local/templates/redesign/src/assets/img/private/callback/error@2.webp');
        }

        @include mobile {
            background-image: url('/local/templates/redesign/src/assets/img/private/callback/error.webp');
            @include retina {
                background-image: url('/local/templates/redesign/src/assets/img/private/callback/error_mob@2.webp');
            }
        }
    }
}
</style>
